import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { styled } from "@mui/material";

const DialogActionsContainer = styled(DialogActions)`
  &.MuiDialogActions-root {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
`;

function DeleteAsepticTemplateDialog(props: any) {
  const handleDelete = () => {
    props.handleClose(true);
    props.setOpen(false);
  };
  const handleClose = () => {
    props.handleClose(false);
    props.setOpen(false);
  };
  

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        data-testid="DeleteAsepticTemplatePopup"
      >
        <DialogTitle
          id="form-dialog-title"
          sx={{ fontSize: "16px", textAlign: "center", padding: "16px" }}
        >
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: "14px", padding: "0 16px" }}>
            {`Are you sure you want to delete ${props.selectedTemplate?.name}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActionsContainer>
          <Button
            onClick={handleClose}
            color="primary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary" variant="outlined">
              Delete
          </Button>
        </DialogActionsContainer>
      </Dialog>
    </div>
  );
}

export default DeleteAsepticTemplateDialog;
